import {charcoal} from '../../sass/v2/_exports.sass';

export const FavoriteHeartIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      role="img"
      aria-label="Filled Heart"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16508_136198)">
        <path
          d="M15.9899 26.28C15.7044 26.28 15.4176 26.2288 15.1296 26.1263C14.8416 26.0237 14.5882 25.863 14.3693 25.6443L12.4539 23.9033C10.0899 21.7478 7.97927 19.6302 6.12194 17.5507C4.2646 15.4711 3.33594 13.2433 3.33594 10.8673C3.33594 8.97513 3.97394 7.3909 5.24994 6.11468C6.52616 4.83868 8.11038 4.20068 10.0026 4.20068C11.0777 4.20068 12.1397 4.44857 13.1886 4.94435C14.2373 5.44013 15.1753 6.24524 16.0026 7.35968C16.8299 6.24524 17.7679 5.44013 18.8166 4.94435C19.8655 4.44857 20.9275 4.20068 22.0026 4.20068C23.8948 4.20068 25.479 4.83868 26.7553 6.11468C28.0313 7.3909 28.6693 8.97513 28.6693 10.8673C28.6693 13.2691 27.7248 15.5217 25.8359 17.625C23.947 19.7283 21.841 21.8279 19.5179 23.9237L17.6229 25.6443C17.4043 25.863 17.1488 26.0237 16.8566 26.1263C16.5642 26.2288 16.2753 26.28 15.9899 26.28Z"
          fill={color}
          fillOpacity="0.25"
          className="favorite-heart--inner-content"
        />
        <g filter="url(#filter0_d_16508_136198)">
          <path
            d="M15.9899 26.2795C15.7044 26.2795 15.4176 26.2283 15.1296 26.1259C14.8416 26.0232 14.5882 25.8625 14.3693 25.6439L12.4539 23.9029C10.0899 21.7473 7.97927 19.6297 6.12194 17.5502C4.2646 15.4706 3.33594 13.2429 3.33594 10.8669C3.33594 8.97464 3.97394 7.39042 5.24994 6.11419C6.52616 4.83819 8.11038 4.2002 10.0026 4.2002C11.0777 4.2002 12.1397 4.44808 13.1886 4.94386C14.2373 5.43964 15.1753 6.24475 16.0026 7.3592C16.8299 6.24475 17.7679 5.43964 18.8166 4.94386C19.8655 4.44808 20.9275 4.2002 22.0026 4.2002C23.8948 4.2002 25.479 4.83819 26.7553 6.11419C28.0313 7.39042 28.6693 8.97464 28.6693 10.8669C28.6693 13.2686 27.7248 15.5212 25.8359 17.6245C23.947 19.7279 21.841 21.8274 19.5179 23.9232L17.6229 25.6439C17.4043 25.8625 17.1488 26.0232 16.8566 26.1259C16.5642 26.2283 16.2753 26.2795 15.9899 26.2795ZM15.0436 9.38486C14.3223 8.28575 13.5628 7.48019 12.7653 6.96819C11.9679 6.45619 11.047 6.2002 10.0026 6.2002C8.66927 6.2002 7.55816 6.64464 6.66927 7.53353C5.78038 8.42242 5.33594 9.53353 5.33594 10.8669C5.33594 11.9369 5.68083 13.0556 6.3706 14.2232C7.06038 15.3907 7.92616 16.5514 8.96794 17.7052C10.0097 18.8592 11.1384 19.9865 12.3539 21.0872C13.5693 22.1881 14.6957 23.2112 15.7333 24.1565C15.8102 24.225 15.8999 24.2592 16.0026 24.2592C16.1053 24.2592 16.195 24.225 16.2719 24.1565C17.3095 23.2112 18.4359 22.1881 19.6513 21.0872C20.8668 19.9865 21.9955 18.8592 23.0373 17.7052C24.0791 16.5514 24.9448 15.3907 25.6346 14.2232C26.3244 13.0556 26.6693 11.9369 26.6693 10.8669C26.6693 9.53353 26.2248 8.42242 25.3359 7.53353C24.4471 6.64464 23.3359 6.2002 22.0026 6.2002C20.9582 6.2002 20.0373 6.45619 19.2399 6.96819C18.4424 7.48019 17.6829 8.28575 16.9616 9.38486C16.8487 9.55575 16.7068 9.68397 16.5359 9.76953C16.365 9.85486 16.1873 9.89753 16.0026 9.89753C15.8179 9.89753 15.6402 9.85486 15.4693 9.76953C15.2984 9.68397 15.1565 9.55575 15.0436 9.38486Z"
            fill="white"
            className="favorite-heart--outter-content"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_16508_136198"
          x="-0.664062"
          y="1.2002"
          width="33.3359"
          height="30.0791"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.52956 0 0 0 0 0.52956 0 0 0 0 0.52956 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16508_136198"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16508_136198"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_16508_136198">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
